// Normalised API error. Backend envelope:
//   { code: string, message: string, message_key?: string, details?: object }

export interface APIErrorPayload {
  code?: string;
  message?: string;
  message_key?: string;
  details?: Record<string, unknown>;
}

export class APIError extends Error {
  status: number;
  code: string;
  messageKey: string | undefined;
  details: Record<string, unknown> | undefined;

  constructor(status: number, payload: APIErrorPayload | undefined, fallbackMessage = 'Request failed') {
    super(payload?.message ?? fallbackMessage);
    this.name = 'APIError';
    this.status = status;
    this.code = payload?.code ?? `http_${status}`;
    this.messageKey = payload?.message_key;
    this.details = payload?.details;
  }

  // i18n key for UI; falls back to a generic key by status.
  get i18nKey(): string {
    if (this.messageKey) return this.messageKey;
    if (this.status === 401) return 'errors.unauthorized';
    if (this.status === 404) return 'errors.not_found';
    if (this.status === 422) return 'errors.validation';
    return 'errors.generic';
  }
}

export function isAPIError(e: unknown): e is APIError {
  return e instanceof APIError;
}
